enum StatoImpianto {
    OK = 0,
    WARNING = 1,
    ERROR = 2,
}

export { StatoImpianto }
